export default __webpack_public_path__ + "static/nano_horz_color-2x-ad45b3e69e3417a418a981dc8151fb8e.jpg";